import React, { createContext, useContext, useEffect, useState } from "react";

const StateContextInfo = createContext();

export const ContextProviderInfo = ({ children }) => {
  const [toastCh, setToast] = useState(false);
  const [dataToas, setDtToas] = useState({
    type: "success",
    sms: [
      {
        value: "",
        msg: "Exitoso!",
        param: "nodo",
        location: "body",
      },
      { value: "", msg: "Operacion exitosa!", param: "name", location: "body" },
    ],
  });
  const [coords, setCoords] = useState([]);

  const [response, setResp] = useState();
  useEffect(() => {
    loadResp();
  }, [response]);

  const loadResp = () => {
    if (response) {
      let newToas;

      if (response.ok) {
        newToas = { type: "success", sms: [{ ...response }] };
      } else if (!response.ok || response.errors) {
        newToas = { type: "error", sms: response.errors || [{ ...response }] };
      } else {
        newToas = {
          type: "error",
          sms: [
            { msg: "Ocurrió un error, si el problema persiste ponte en contacto con el administrador." },
          ],
        };
      }

      setDtToas(newToas);
      setToast(true);
    }
  };  

  return (
    <StateContextInfo.Provider
      value={{
        toastCh,
        setDtToas,
        setToast,
        dataToas,
        setCoords,
        coords,
        response,
        setResp,
      }}
    >
      {children}
    </StateContextInfo.Provider>
  );
};

export const useContextInfo = () => useContext(StateContextInfo);
